import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

/* Icons are imported where they're used (see TwoFactorAuthCard) rather than
   registered globally. Registering the whole set pulled all 293 icon components
   into the bundle - ~204KB minified - to render the single one this app uses.
   Element Plus's own components import the icons they need directly, so they are
   unaffected. */
export function setupPlugins (app) {
  app.use(ElementPlus)
}
